import { useEffect, useState } from "react";
import { PharmaQuestionModel } from "../../../data-model/pharmaQuestion";
import RenderAnswerSection from "./renderAnswerSection";

interface PharmaQuestionsProps {
  questions: PharmaQuestionModel[];
  onQuestionUpdated?: (questions: PharmaQuestionModel[]) => void;
}

const PharmaQuestions = (props: PharmaQuestionsProps) => {
  const [questionsWithResponse, setQuestionsWithResponse] = useState<
    PharmaQuestionModel[]
  >([]);

  useEffect(() => {
    if (props.questions) {
      setQuestionsWithResponse([...props.questions]);
    }
  }, [props.questions]);

  const updateQuestionWithResponseAtIndex = (value: string, index: number) => {
    setQuestionsWithResponse((prev) =>
      prev.map((question, i) =>
        i === index ? { ...question, answer: value } : question,
      ),
    );
  };

  const updateCombinedQuestionWithResponseAtIndex = (
    value: { multiChoiceAnswer: string; subjectiveAnswer: string },
    index: number,
  ) => {
    setQuestionsWithResponse((prev) =>
      prev.map((question, i) =>
        i === index
          ? {
              ...question,
              combined_answer: {
                multiChoiceAnswer: value.multiChoiceAnswer,
                subjectiveAnswer: value.subjectiveAnswer,
              },
            }
          : question,
      ),
    );
  };

  useEffect(() => {
    if (props.onQuestionUpdated) {
      props.onQuestionUpdated(questionsWithResponse);
    }
  }, [questionsWithResponse]);

  return (
    <>
      {questionsWithResponse.length > 0 ? (
        <>
          {questionsWithResponse?.map((question, index) => (
            <div
              key={index}
              className={`pharma-question--container flex gap-1 ${question?.isDiffData ? "has-diff" : ""} ${question?.isMissingData ? "bg-tertiaryRed-11" : ""} ${question?.isNewData ? "bg-primaryGreen-11" : ""} ${question?.isAnswerChanged ? "bg-secondaryYellow-11" : ""} `}
            >
              <div className="question-index text-small font-semibold">
                {index + 1}.
              </div>
              <div className="question-body flex-1">
                <div className="pharma-question--question text-small font-semibold">
                  {question.question ?? ""}
                </div>
                <div className="pharma-question--answer mb-6">
                  <RenderAnswerSection
                    question={question}
                    onHandleChange={(value) =>
                      updateQuestionWithResponseAtIndex(value, index)
                    }
                    onCombinedHandleChange={(value) => {
                      updateCombinedQuestionWithResponseAtIndex(value, index);
                    }}
                  />
                </div>
                <div className="pharma-question--facts flex flex-col gap-2">
                  {question?.api_response?.facts?.supportive_facts &&
                    question?.api_response?.facts?.supportive_facts.length >
                      0 && (
                      <>
                        <div className="pharma-question--facts correct rounded bg-[#E9FFF4] p-3">
                          <div className="facts-header mb-2 text-[0.8125rem] font-bold">
                            Supportive Statement
                          </div>
                          <ul className="facts-container flex flex-col gap-1">
                            <RenderFacts
                              facts={
                                question?.api_response?.facts?.supportive_facts
                              }
                            />
                          </ul>
                        </div>
                      </>
                    )}

                  <div className="pharma-questions--facts incorrect">
                    {" "}
                    {question?.api_response?.facts?.contradictory_facts &&
                      question?.api_response?.facts?.contradictory_facts
                        .length > 0 && (
                        <>
                          <div className="pharma-question--facts contradictory rounded bg-[#FFFAE6] p-3">
                            <div className="facts-header mb-2 text-[0.8125rem] font-bold">
                              Contracdictory Statement
                            </div>
                            <ul className="facts-container flex flex-col gap-1">
                              <RenderFacts
                                facts={
                                  question?.api_response?.facts
                                    ?.contradictory_facts
                                }
                              />
                            </ul>
                          </div>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          <div className="pharma-question--container flex h-full items-center justify-center gap-1 text-h10">
            No questions found
          </div>
        </>
      )}
    </>
  );
};

const RenderFacts = (props: { facts: string[] }) => {
  return (
    <>
      {props.facts.map((fact) => (
        <>
          <li className="facts-content text-[0.8125rem]" key={fact}>
            &#8226;&nbsp;&nbsp;{fact}
          </li>
        </>
      ))}
    </>
  );
};

export default PharmaQuestions;
